module.exports = __webpack_public_path__ + "static/media/0_2020_06_03.2453339a.jpg";